/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react"
import { Canvas } from "react-three-fiber"
import "./App.css"
import Controls from "./components/Controls"
import { Chill, Chillup, Hype, Pop } from "./data/songs"
import useWindowSize from "./hooks/useWindowSize"
import { UntitledLogo } from "./icons/Icons"
import Visualizer from "./Three/Visualizer"

let audio = {},
  source,
  volumeControl,
  analyzer,
  audioCtx

audio.currentTime = 0

function App() {
  let factor = null
  let setFactor = null

  function readFile(files) {
    setPausedBtn(true)
    var fileReader = new FileReader()
    fileReader.readAsArrayBuffer(files[0])
    fileReader.onload = function (e) {
      const blob = new Blob([e.target.result], { type: "audio/mp3" })
      const url = window.URL.createObjectURL(blob)
      audio.src = url
      audio.play()
      console.log(
        "Filename: '" + files[0].name + "'",
        "(" + Math.floor((files[0].size / 1024 / 1024) * 100) / 100 + " MB)"
      )
    }
  }

  const onFactorUpdate = (dataFromChild) => {
    factor = dataFromChild[0]
    setFactor = dataFromChild[1]
  }

  const [navOpened, setNavOpened] = useState(false)

  const size = useWindowSize()
  const scrollContainer = useRef()
  const data = {
    ease: 0.08,
    current: 0,
    previous: 0,
    rounded: 0,
  }

  const [activeMenu, setActiveMenu] = useState(Chillup)
  const [songActiveCategory, setSongActiveCategory] = useState(Chillup)
  const [theme, setTheme] = useState(true)
  const [volumeNumber, setVolumeNumber] = useState(1)
  const [currentTime, setCurrentTime] = useState(0)
  const [mood, setMood] = useState(Chillup)
  const [orderNumber, setOrderNumber] = useState(0)
  const [pausedBtn, setPausedBtn] = useState(false)
  const [initBeatRecSetup, setInitBeatRecSetup] = useState(false)
  const [coverFade, setCoverFade] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(audio.currentTime)
    }, 100)
    return () => {
      clearInterval(interval)
    }
  }, [audio.currentTime])

  const CategoryList = ({ category }) => {
    return (
      <>
        {category.map((song, index) => (
          <a
            className="menu__item btn"
            onClick={() => {
              setMood(category)
              playSet(index)
              setNavOpened(false)
            }}
            onMouseOver={() => setActiveMenu(category)}
          >
            <span className="menu__item-text">
              <h1 className="menu__item-textinner">
                {sentenceCase(song.name)}
              </h1>
            </span>
          </a>
        ))}
      </>
    )
  }

  //set the height of the body.
  useEffect(() => {
    setBodyHeight()
  }, [navOpened, size.height])

  const setBodyHeight = () => {
    if (navOpened) {
      document.body.style.height = `${
        scrollContainer.current.getBoundingClientRect().height + 250
      }px`
    } else {
      document.body.style.height = "auto"
    }
  }

  // Scrolling
  const skewScrolling = () => {
    data.current = window.scrollY

    data.previous += (data.current - data.previous) * data.ease

    data.rounded = Math.round(data.previous * 100) / 100

    const difference = data.current - data.rounded
    const acceleration = difference / size.width
    const velocity = +acceleration
    const skew = velocity * 10

    if (navOpened && scrollContainer.current) {
      scrollContainer.current.style.transform = `translate3d(0, -${data.rounded}px, 0) skewY(${skew}deg)`
    }

    requestAnimationFrame(() => skewScrolling())
  }

  useEffect(() => {
    requestAnimationFrame(() => skewScrolling())
  }, [navOpened])

  useEffect(() => {
    // create the new audio
    audio = new Audio()
    console.log("Audio Created")
    audio.src = `https://res.cloudinary.com/musixdevelop/video/upload/track-audios/${mood[orderNumber].name}.mp3`

    audio.crossOrigin = "anonymous"
    audio.volume = volumeNumber

    document.body.appendChild(audio)

    animate()
    window.addEventListener("keypress", (e) => {
      if (e.which === 32) {
        document.getElementById("pauseOrResume").click()
      }
    })

    function handleCheckboxEvent(e) {
      if (e.keyCode === 32) {
        // If spacebar fired the event
        e.preventDefault()
      }
    }

    window.addEventListener("click", handleCheckboxEvent, true)
    window.addEventListener("keyup", handleCheckboxEvent, true)
  }, [])

  // helper function to map scales
  const numscale = (num, in_min, in_max, out_min, out_max) => {
    return ((num - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
  }
  function randomIntFromInterval(min, max) {
    // min and max included
    return Math.random() * (max - min) + min
  }
  //render the sucker
  function render(freqData) {
    setFactor(
      numscale(freqData[0], 0, 270, randomIntFromInterval(0.022, 0.023), 0.4)
    )
  }

  // rAF and get the frequency data from the audio all the time so we can use it to update the amplitude
  const animate = () => {
    let freqData
    if (analyzer) {
      freqData = new Uint8Array(analyzer.frequencyBinCount)
      analyzer.getByteFrequencyData(freqData)
      render(freqData)
    }
    requestAnimationFrame(animate)
  }

  const getBeat = (audio) => {
    if (initBeatRecSetup) {
      audioCtx = new (window.AudioContext || window.webkitAudioContext)()
    } else {
      audioCtx = new (window.AudioContext || window.webkitAudioContext)()
      source = audioCtx.createMediaElementSource(audio)
      volumeControl = audioCtx.createGain()
      analyzer = audioCtx.createAnalyser()
      source.connect(volumeControl)
      analyzer.connect(audioCtx.destination)
      volumeControl.connect(analyzer)
      setInitBeatRecSetup(true)
    }
  }

  const play = (number) => {
    setCoverFade(true)
    setTimeout(() => {
      setCoverFade(false)
    }, 1000)
    setPausedBtn(true)
    setSongActiveCategory(activeMenu)
    audio.src = `https://res.cloudinary.com/musixdevelop/video/upload/track-audios/${activeMenu[number].name}.mp3`
    audio.play()
  }

  const playSetNextOrPrevious = (number) => {
    setCoverFade(true)
    setTimeout(() => {
      setCoverFade(false)
    }, 1000)
    setPausedBtn(true)
    audio.src = `https://res.cloudinary.com/musixdevelop/video/upload/track-audios/${mood[number].name}.mp3`
    setActiveMenu(mood)
    audio.play()
    setOrderNumber(number)
  }
  const pauseOrResume = () => {
    getBeat(audio)
    if (audio.paused) {
      audio.play()
      setPausedBtn(true)
    } else {
      audio.pause()
      setPausedBtn(false)
    }
  }
  const muteOrUnmute = () => {
    switch (audio.volume) {
      case 0:
        audio.volume = volumeNumber
        break
      case audio.volume:
        setVolumeNumber(audio.volume)
        audio.volume = 0
        break
      default:
        break
    }
  }
  const handleVolumeChange = (newValue) => {
    audio.volume = newValue / 100
    setVolumeNumber(audio.volume)
  }
  const handleTimeChange = (newValue) => {
    audio.currentTime = newValue
  }
  const playSet = (number) => {
    play(number)
    setOrderNumber(number)
  }
  const nextOrPrevious = (type) => {
    getBeat(audio)
    switch (type) {
      case "next":
        if (mood.length > orderNumber + 1) {
          playSetNextOrPrevious(orderNumber + 1)
        }
        break
      case "prev":
        if (orderNumber !== 0) {
          if (mood.length > orderNumber - 1) {
            playSetNextOrPrevious(orderNumber - 1)
          } else {
            playSetNextOrPrevious(mood.length - 1)
          }
        }
        break
      default:
        break
    }
  }
  const sentenceCase = (name) => {
    return (
      name
        .replace(/([A-Z])/g, " $1")
        .charAt(0)
        .toUpperCase() + name.replace(/([A-Z])/g, " $1").slice(1)
    )
  }

  return (
    <>
      <div className="header-container">
        <svg
          className={`${theme ? "darkMood" : "lightMood"}`}
          onClick={() => {
            if (navOpened) {
              switch (mood) {
                case Hype:
                  setMood(Chillup)
                  break
                case Chillup:
                  setMood(Pop)
                  break
                case Pop:
                  setMood(Chill)
                  break
                case Chill:
                  setMood(Hype)
                  break
                default:
                  setMood(Hype)
                  break
              }
            } else {
              setTheme(!theme)
            }
          }}
        >
          {navOpened ? (
            <path
              id="Mood"
              d="M24877,27390.264v-1.113a22.076,22.076,0,0,1,22.082-21.152,22.267,22.267,0,1,1-22.082,22.266Zm23.938,0a8.35,8.35,0,1,0,16.7,0,18.815,18.815,0,0,0-7.422-14.844,18.607,18.607,0,0,0-25.977,3.711,12.9,12.9,0,0,1,4.637-.93A12.04,12.04,0,0,1,24900.934,27390.264Zm-16.7,0a3.711,3.711,0,1,0,3.707-3.711A3.72,3.72,0,0,0,24884.234,27390.264Zm22.266,0a3.711,3.711,0,1,1,3.711,3.711A3.711,3.711,0,0,1,24906.5,27390.264Z"
              transform="translate(-24876.996 -27367.999)"
            />
          ) : (
            <g>
              <g>
                <path
                  d="M22.58,11.269c-6.237,0-11.311,5.075-11.311,11.312s5.074,11.312,11.311,11.312c6.236,0,11.311-5.074,11.311-11.312
			S28.816,11.269,22.58,11.269z"
                />
                <g>
                  <g>
                    <path
                      d="M22.58,7.944c-1.219,0-2.207-0.988-2.207-2.206V2.207C20.373,0.988,21.361,0,22.58,0c1.219,0,2.207,0.988,2.207,2.207
					v3.531C24.787,6.956,23.798,7.944,22.58,7.944z"
                    />
                  </g>
                  <g>
                    <path
                      d="M22.58,37.215c-1.219,0-2.207,0.988-2.207,2.207v3.53c0,1.22,0.988,2.208,2.207,2.208c1.219,0,2.207-0.988,2.207-2.208
					v-3.53C24.787,38.203,23.798,37.215,22.58,37.215z"
                    />
                  </g>
                  <g>
                    <path
                      d="M32.928,12.231c-0.861-0.862-0.861-2.259,0-3.121l2.497-2.497c0.861-0.861,2.259-0.861,3.121,0
					c0.862,0.862,0.862,2.26,0,3.121l-2.497,2.497C35.188,13.093,33.791,13.093,32.928,12.231z"
                    />
                  </g>
                  <g>
                    <path
                      d="M12.231,32.93c-0.862-0.863-2.259-0.863-3.121,0l-2.497,2.496c-0.861,0.861-0.862,2.26,0,3.121
					c0.862,0.861,2.26,0.861,3.121,0l2.497-2.498C13.093,35.188,13.093,33.79,12.231,32.93z"
                    />
                  </g>
                  <g>
                    <path
                      d="M37.215,22.58c0-1.219,0.988-2.207,2.207-2.207h3.531c1.219,0,2.207,0.988,2.207,2.207c0,1.219-0.988,2.206-2.207,2.206
					h-3.531C38.203,24.786,37.215,23.799,37.215,22.58z"
                    />
                  </g>
                  <g>
                    <path
                      d="M7.944,22.58c0-1.219-0.988-2.207-2.207-2.207h-3.53C0.988,20.373,0,21.361,0,22.58c0,1.219,0.988,2.206,2.207,2.206
					h3.531C6.956,24.786,7.944,23.799,7.944,22.58z"
                    />
                  </g>
                  <g>
                    <path
                      d="M32.928,32.93c0.862-0.861,2.26-0.861,3.121,0l2.497,2.497c0.862,0.86,0.862,2.259,0,3.12s-2.259,0.861-3.121,0
					l-2.497-2.497C32.066,35.188,32.066,33.791,32.928,32.93z"
                    />
                  </g>
                  <g>
                    <path
                      d="M12.231,12.231c0.862-0.862,0.862-2.259,0-3.121L9.734,6.614c-0.862-0.862-2.259-0.862-3.121,0
					c-0.862,0.861-0.862,2.259,0,3.12l2.497,2.497C9.972,13.094,11.369,13.094,12.231,12.231z"
                    />
                  </g>
                </g>
              </g>
            </g>
          )}
        </svg>
        <input
          type="checkbox"
          id="main-navigation-toggle"
          checked={navOpened}
          class="btn btn--close"
          title="Toggle main navigation"
          onClick={() => {
            navOpened && setActiveMenu(songActiveCategory)
            setNavOpened(!navOpened)
            getBeat(audio)
          }}
        />
        <label for="main-navigation-toggle">
          <span></span>
        </label>
      </div>
      <div
        className={`menu-container ${
          navOpened ? "menu-opened" : "menu-closed"
        }`}
      >
        {navOpened && (
          <nav ref={scrollContainer} className="menu">
            <CategoryList category={Hype} />
            <CategoryList category={Chillup} />
            <CategoryList category={Pop} />
            <CategoryList category={Chill} />
          </nav>
        )}
      </div>

      <div className="App">
        <Canvas
          style={{
            height: window.innerHeight,
            width: window.innerWidth,
          }}
        >
          <Visualizer
            onFactorUpdate={onFactorUpdate}
            mood={mood}
            theme={theme}
          />
        </Canvas>
        <div className="player">
          <div>
            {audio.src &&
              audio.src.split(
                "https://res.cloudinary.com/musixdevelop/video/upload/track-audios/"
              )[1] &&
              activeMenu[orderNumber] && (
                <img
                  className={`playingMusic-cover ${
                    coverFade && "playingMusic-cover-fade"
                  } ${navOpened ? "fade-out" : "fade-in"}`}
                  id="music-cover"
                  src={`https://res.cloudinary.com/musixdevelop/image/upload/track-covers/${activeMenu[orderNumber].name}.jpg`}
                  alt="cover"
                />
              )}
          </div>
          <div
            className={`playingMusic-info ${
              navOpened ? "fade-out" : "fade-in"
            }`}
          >
            <h1 className="playingMusic-songName">
              {audio.src &&
                activeMenu[orderNumber] &&
                audio.src.split(
                  "https://res.cloudinary.com/musixdevelop/video/upload/track-audios/"
                )[1] &&
                sentenceCase(activeMenu[orderNumber].name)}
            </h1>
            <h1 className="playingMusic-artistName">
              {audio.src &&
                activeMenu[orderNumber] &&
                audio.src.split(
                  "https://res.cloudinary.com/musixdevelop/video/upload/track-audios/"
                )[1] &&
                activeMenu[orderNumber].artist}
            </h1>
          </div>
          <div className={`${navOpened ? "fade-out" : "fade-in"}`}>
            <Controls
              playNextOrPrevious={nextOrPrevious}
              pauseOrResume={pauseOrResume}
              pausedBtn={pausedBtn}
              currentTime={currentTime}
              audio={audio}
              muteOrUnmute={muteOrUnmute}
              handleTimeChange={handleTimeChange}
              volumeNumber={volumeNumber}
              handleVolumeChange={handleVolumeChange}
              setCurrentTime={setCurrentTime}
            />
          </div>
        </div>
      </div>
      <div className="addButton-container" id="addButton-container">
        <label for="audioFileChooser" id="addButton-label">
          <div
            className={`addButton-button ${
              navOpened ? "fade-out" : "fade-in"
            } `}
            id="addButton-button"
            onMouseOver={() =>
              document
                .getElementById("addButton-button")
                .classList.add("addButton-hover")
            }
            onMouseLeave={() =>
              document
                .getElementById("addButton-button")
                .classList.remove("addButton-hover")
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
            >
              <g
                id="Group_2"
                data-name="Group 2"
                transform="translate(-279 -399)"
              >
                <rect
                  id="Rectangle_2"
                  data-name="Rectangle 2"
                  width="8"
                  height="40"
                  rx="4"
                  transform="translate(295 399)"
                />
                <rect
                  id="Rectangle_3"
                  data-name="Rectangle 3"
                  width="8"
                  height="40"
                  rx="4"
                  transform="translate(319 415) rotate(90)"
                />
              </g>
            </svg>
          </div>
        </label>
        <input
          onClick={() => getBeat(audio)}
          id="audioFileChooser"
          type="file"
          onChange={(e) => readFile(e.target.files)}
        />
      </div>
    </>
  )
}

export default App
